import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NavigationModule } from './navigation/navigation.module';
import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
import { LayoutComponent } from './layout.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { RefreshTokenWrapperComponent } from './refresh-token-wrapper/refresh-token-wrapper.component';
import { IdleTimeoutWrapperModule } from './idle-timeout-wrapper/idle-timeout-wrapper.module';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import '@upmc-healthplan-npm/ods-wc';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HeaderModule,
    NavigationModule,
    FooterModule,
    IdleTimeoutWrapperModule,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    LayoutComponent,
    BreadcrumbComponent,
    RefreshTokenWrapperComponent,
    TermsAndConditionsComponent
  ],
  exports: []
})
export class LayoutModule {}
